import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getConfiguracoes as getConfiguracoesSdk,
  getConfiguracao as getConfiguracaoSdk,
  postConfiguracao as postConfiguracaoSdk,
  putConfiguracao as putConfiguracaoSdk,
  deleteConfiguracao as deleteConfiguracaoSdk,
  getClientesConfiguracoes as getClientesSdk,
} from '@sdk/Conectores/Configuracoes';

//Action Types
export const Types = {
  GET_CLIENTES: 'GET_CLIENTES',
  GET_CLIENTES_SUCCESS: 'GET_CLIENTES_SUCCESS',
  GET_CLIENTES_ERROR: 'GET_CLIENTES_ERROR',

  GET_CONFIGURACOES: 'GET_CONFIGURACOES',
  GET_CONFIGURACOES_SUCCESS: 'GET_CONFIGURACOES_SUCCESS',
  GET_CONFIGURACOES_ERROR: 'GET_CONFIGURACOES_ERROR',

  GET_CONFIGURACAO: 'GET_CONFIGURACAO',
  GET_CONFIGURACAO_SUCCESS: 'GET_CONFIGURACAO_SUCCESS',
  GET_CONFIGURACAO_ERROR: 'GET_CONFIGURACAO_ERROR',

  PUT_CONFIGURACAO: 'PUT_CONFIGURACAO',
  PUT_CONFIGURACAO_SUCCESS: 'PUT_CONFIGURACAO_SUCCESS',
  PUT_CONFIGURACAO_ERROR: 'PUT_CONFIGURACAO_ERROR',

  POST_CONFIGURACAO: 'POST_CONFIGURACAO',
  POST_CONFIGURACAO_SUCCESS: 'POST_CONFIGURACAO_SUCCESS',
  POST_CONFIGURACAO_ERROR: 'POST_CONFIGURACAO_ERROR',

  DELETE_CONFIGURACAO: 'DELETE_CONFIGURACAO',
  DELETE_CONFIGURACAO_SUCCESS: 'DELETE_CONFIGURACAO_SUCCESS',
  DELETE_CONFIGURACAO_ERROR: 'DELETE_CONFIGURACAO_ERROR',

  RESET: 'RESET',
};

//Action Creators
export const getClientes = () => ({ type: Types.GET_CLIENTES });
export const getClientesSuccess = (clientes) => ({ type: Types.GET_CLIENTES_SUCCESS, clientes });
export const getClientesError = (error) => ({ type: Types.GET_CLIENTES_ERROR, error });

export const getConfiguracoes = (idCliente) => ({ type: Types.GET_CONFIGURACOES, idCliente });
export const getConfiguracoesSuccess = (configuracoes) => ({ type: Types.GET_CONFIGURACOES_SUCCESS, configuracoes });
export const getConfiguracoesError = (error) => ({ type: Types.GET_CONFIGURACOES_ERROR, error });

export const getConfiguracao = (idConfiguracao) => ({ type: Types.GET_CONFIGURACAO, idConfiguracao });
export const getConfiguracaoSuccess = (configuracao) => ({ type: Types.GET_CONFIGURACAO_SUCCESS, configuracao });
export const getConfiguracaoError = (error) => ({ type: Types.GET_CONFIGURACAO_ERROR, error });

export const postConfiguracao = (data) => ({ type: Types.POST_CONFIGURACAO, data });
export const postConfiguracaoSuccess = () => ({ type: Types.POST_CONFIGURACAO_SUCCESS });
export const postConfiguracaoError = (error) => ({ type: Types.POST_CONFIGURACAO_ERROR, error });

export const putConfiguracao = (data) => ({ type: Types.PUT_CONFIGURACAO, data });
export const putConfiguracaoSuccess = () => ({ type: Types.PUT_CONFIGURACAO_SUCCESS });
export const putConfiguracaoError = (error) => ({ type: Types.PUT_CONFIGURACAO_ERROR, error });

export const deleteConfiguracao = (id) => ({ type: Types.DELETE_CONFIGURACAO, id });
export const deleteConfiguracaoSuccess = (id) => ({ type: Types.DELETE_CONFIGURACAO_SUCCESS, id });
export const deleteConfiguracaoError = (error) => ({ type: Types.DELETE_CONFIGURACAO_ERROR, error });

export const reset = () => ({ type: Types.RESET });

//saga
function* fetchGetClientes(action) {
  try {
    const clientes = yield call(getClientesSdk);
    yield put(getClientesSuccess(clientes));
  } catch (err) {
    Notification.error(err.message);
    yield put(getClientesError(err));
  }
}

function* fetchGetConfiguracoes(action) {
  try {
    const configuracoes = yield call(getConfiguracoesSdk, action.idCliente);
    yield put(getConfiguracoesSuccess(configuracoes));
  } catch (err) {
    Notification.error(err.message);
    yield put(getConfiguracoesError(err));
  }
}

function* fetchGetConfiguracao(action) {
  try {
    const configuracao = yield call(getConfiguracaoSdk, action.idConfiguracao);
    yield put(getConfiguracaoSuccess(configuracao));
  } catch (err) {
    Notification.error(err.message);
    yield put(getConfiguracaoError(err));
  }
}

function* fetchPutConfiguracao(action) {
  try {
    yield call(putConfiguracaoSdk, action.data);
    yield put(putConfiguracaoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putConfiguracaoError(err));
  }
}

function* fetchPostConfiguracao(action) {
  try {
    yield call(postConfiguracaoSdk, action.data);
    yield put(postConfiguracaoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postConfiguracaoError(err));
  }
}

function* fetchDeleteConfiguracao(action) {
  try {
    const { id } = action;
    yield call(deleteConfiguracaoSdk, id);
    yield put(deleteConfiguracaoSuccess(id));
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteConfiguracaoError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_CLIENTES, fetchGetClientes),
  takeLatest(Types.GET_CONFIGURACOES, fetchGetConfiguracoes),
  takeLatest(Types.GET_CONFIGURACAO, fetchGetConfiguracao),
  takeLatest(Types.PUT_CONFIGURACAO, fetchPutConfiguracao),
  takeLatest(Types.POST_CONFIGURACAO, fetchPostConfiguracao),
  takeLatest(Types.DELETE_CONFIGURACAO, fetchDeleteConfiguracao),
];

// Reducer
const initialState = Map({
  clientes: List(),
  configuracoes: List(),
  configuracao: {},

  loadingClientes: false,
  successClientes: false,
  errorClientes: false,

  loadingConfiguracoes: false,
  successConfiguracoes: false,
  errorConfiguracoes: false,

  loadingConfiguracao: false,
  successConfiguracao: false,
  errorConfiguracao: false,

  puttingConfiguracao: false,
  successPutConfiguracao: false,
  errorPutConfiguracao: false,

  postingConfiguracao: false,
  successPostConfiguracao: false,
  errorPostConfiguracao: false,

  deletingConfiguracao: false,
  successDeleteConfiguracao: false,
  errorDeleteConfiguracao: false,
});

const handleGetClientes = (state, action) => {
  return state.set('loadingClientes', true).set('successClientes', false).set('errorClientes', false).set('successPostConfiguracao', false);
};

const handleGetConfiguracoes = (state, action) => {
  return state
    .set('loadingConfiguracoes', true)
    .set('successConfiguracoes', false)
    .set('errorConfiguracoes', false)
    .set('successPutConfiguracao', false)
    .set('configuracao', {});
};

const handleGetConfiguracao = (state, action) => {
  return state.set('loadingConfiguracao', true).set('successConfiguracao', false).set('errorConfiguracao', false);
};

const handlePutConfiguracao = (state, action) => {
  return state.set('puttingConfiguracao', true).set('successPutConfiguracao', false).set('errorPutConfiguracao', false);
};

const handlePostConfiguracao = (state, action) => {
  return state.set('postingConfiguracao', true).set('successPostConfiguracao', false).set('errorPostConfiguracao', false);
};

const handleDeleteConfiguracao = (state, action) => {
  return state.set('deletingConfiguracao', true).set('successDeleteConfiguracao', false).set('errorDeleteConfiguracao', false);
};

const handleGetClientesSuccess = (state, action) => {
  const { clientes } = action;
  return state.set('clientes', List(clientes)).set('loadingClientes', false).set('successClientes', true).set('errorClientes', false);
};

const handleGetConfiguracoesSuccess = (state, action) => {
  const { configuracoes } = action;
  return state
    .set('configuracoes', List(configuracoes))
    .set('loadingConfiguracoes', false)
    .set('successConfiguracoes', true)
    .set('errorConfiguracoes', false);
};

const handleGetConfiguracaoSuccess = (state, action) => {
  const { configuracao } = action;

  return state
    .set('configuracao', configuracao[0])
    .set('loadingConfiguracao', false)
    .set('successConfiguracao', true)
    .set('errorConfiguracao', false);
};

const handlePutConfiguracaoSuccess = (state, action) => {
  return state.set('puttingConfiguracao', false).set('successPutConfiguracao', true).set('errorPutConfiguracao', false);
};

const handlePostConfiguracaoSuccess = (state, action) => {
  return state.set('posttingConfiguracao', false).set('successPostConfiguracao', true).set('errorPostConfiguracao', false);
};

const handleDeleteConfiguracaoSuccess = (state, action) => {
  const { id } = action;
  const configuracoes = state.get('configuracoes').filter((value, index, arr) => value.id !== id);
  return state
    .set('deletingConfiguracao', false)
    .set('successDeleteConfiguracao', true)
    .set('errorDeleteConfiguracao', false)
    .set('configuracoes', configuracoes);
};

const handleGetClientesError = (state, action) => {
  return state.set('loadingClientes', false).set('successClientes', false).set('errorClientes', action.error);
};

const handleGetConfiguracoesError = (state, action) => {
  return state.set('loadingConfiguracoes', false).set('successConfiguracoes', false).set('errorConfiguracoes', action.error);
};

const handleGetConfiguracaoError = (state, action) => {
  return state.set('loadingConfiguracao', false).set('successConfiguracao', false).set('errorConfiguracao', action.error);
};

const handlePutConfiguracaoError = (state, action) => {
  return state.set('puttingConfiguracao', false).set('successPutConfiguracao', false).set('errorPutConfiguracao', action.error);
};

const handlePostConfiguracaoError = (state, action) => {
  return state.set('posttingConfiguracao', false).set('successPostConfiguracao', false).set('errorPostConfiguracao', action.error);
};

const handleDeleteConfiguracaoError = (state, action) => {
  return state.set('deletingConfiguracao', false).set('successDeleteConfiguracao', false).set('errorDeleteConfiguracao', action.error);
};

const handleReset = (state, action) => {
  return state.set('successPutConfiguracao', false).set('successPostConfiguracao', false);
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_CLIENTES:
      return handleGetClientes(state, action);
    case Types.GET_CLIENTES_SUCCESS:
      return handleGetClientesSuccess(state, action);
    case Types.GET_CLIENTES_ERROR:
      return handleGetClientesError(state, action);

    case Types.GET_CONFIGURACOES:
      return handleGetConfiguracoes(state, action);
    case Types.GET_CONFIGURACOES_SUCCESS:
      return handleGetConfiguracoesSuccess(state, action);
    case Types.GET_CONFIGURACOES_ERROR:
      return handleGetConfiguracoesError(state, action);

    case Types.GET_CONFIGURACAO:
      return handleGetConfiguracao(state, action);
    case Types.GET_CONFIGURACAO_SUCCESS:
      return handleGetConfiguracaoSuccess(state, action);
    case Types.GET_CONFIGURACAO_ERROR:
      return handleGetConfiguracaoError(state, action);

    case Types.POST_CONFIGURACAO:
      return handlePostConfiguracao(state, action);
    case Types.POST_CONFIGURACAO_SUCCESS:
      return handlePostConfiguracaoSuccess(state, action);
    case Types.POST_CONFIGURACAO_ERROR:
      return handlePostConfiguracaoError(state, action);

    case Types.PUT_CONFIGURACAO:
      return handlePutConfiguracao(state, action);
    case Types.PUT_CONFIGURACAO_SUCCESS:
      return handlePutConfiguracaoSuccess(state, action);
    case Types.PUT_CONFIGURACAO_ERROR:
      return handlePutConfiguracaoError(state, action);

    case Types.DELETE_CONFIGURACAO:
      return handleDeleteConfiguracao(state, action);
    case Types.DELETE_CONFIGURACAO_SUCCESS:
      return handleDeleteConfiguracaoSuccess(state, action);
    case Types.DELETE_CONFIGURACAO_ERROR:
      return handleDeleteConfiguracaoError(state, action);

    case Types.RESET:
      return handleReset(state, action);

    default:
      return state;
  }
}
